import { createSlice } from '@reduxjs/toolkit';
import { registerUser } from '../actions/registerAction';

const initialState = {
  isLoading: false,
  error: null,
  success: false,
  data: null,
};

const registerSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    resetRegisterState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload || 'Registration failed';
      });
  },
});

export const { resetRegisterState } = registerSlice.actions;
export default registerSlice.reducer;
